export function gpsSettings(state) {
  return {
    gpsPluginReady: state.gpsPluginReady,
    gpsAlwaysOn: state.gpsAlwaysOn,
    gpsGeofenceOn: state.gpsGeofenceOn,
    gpsDenied: state.gpsDenied,
    gpsPermissionState: state.gpsPermissionState
  }
}
